import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

export const DEIPageBarChartDIV = styled.div`
`;

export const DEIPageBarChartTitleDIV = styled.div`
  position: relative;

  h3 {
    text-align: center;
    margin: 0 0 20px;

    ${MEDIA_QUERIES.M} {
      margin-bottom: 30px;
    }
  }
  
  select {
    display: block;
    margin: 0 auto 30px;
    max-width: 180px;
  }

  ${MEDIA_QUERIES.M} {
    select {
      position: absolute;
      top: 0;
      right: 0;
      margin: 0;
    }
  }
`;

export const DEIPageBarChartChartDIV = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin: 0 auto;

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 341px; /* Height of maximum percentage label + bar height */
    width: 100%;
    height: 1px;
    background: #d1d7e6;
  }
`;
